import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    AssignOrderPayload,
    ChangeOrderTakeDatePayload,
    ConfirmDatePayload,
    DownloadReportParams,
    GetTakeCommentsResponse,
    GetTakeOrderResponse,
    GetTakeOrdersParams,
    GetTakeOrdersResponse,
    GetWaitListStatusesParams,
    GetWaitListStatusesResponse,
    SetWaitListStatusPayload,
} from '@/new-services/types/takes'

type ApiGetTakeOrdersResponse = Promise<AxiosResponse<GetTakeOrdersResponse>>
type ApiGetTakeOrderResponse = Promise<AxiosResponse<GetTakeOrderResponse>>
type ApiAssignOrderResponse = Promise<AxiosResponse<void>>
type ApiChangeOrderTakeDateResponse = Promise<AxiosResponse<{ message: string }>>
type ApiGetWaitListStatusesResponse = Promise<AxiosResponse<GetWaitListStatusesResponse>>
type ApiGetTakeCommentsResponse = Promise<AxiosResponse<GetTakeCommentsResponse>>
type ApiSetWaitListStatusResponse = Promise<AxiosResponse<void>>
type ApiDownloadReportResponse = Promise<AxiosResponse<any>>

export function getTakeOrders(params: GetTakeOrdersParams): ApiGetTakeOrdersResponse {
    return http.get('/dispatcher/api/order-take', { params })
}

export function getTakeOrder(order_id: number): ApiGetTakeOrderResponse {
    return http.get(`/dispatcher/api/order-take/${order_id}`)
}

export function assignOrder(payload: AssignOrderPayload): ApiAssignOrderResponse {
    return http.post('/dispatcher/api/order-take/assign', payload)
}

export function changeOrderTakeDate(
    payload: ChangeOrderTakeDatePayload
): ApiChangeOrderTakeDateResponse {
    return http.post('/dispatcher/api/order-take/change-date', payload)
}

export function confirmDate(payload: ConfirmDatePayload): ApiChangeOrderTakeDateResponse {
    return http.post(
        '/cabinet/api/dispatcher-admin/take/order/shift-take-date-confirmation',
        payload
    )
}

export function getWaitListStatuses(
    params: GetWaitListStatusesParams
): ApiGetWaitListStatusesResponse {
    return http.get('/cabinet/api/wait-list-statuses', { params })
}

export function setWaitListStatus(
    order_id: number,
    payload: SetWaitListStatusPayload
): ApiSetWaitListStatusResponse {
    return http.put(`/cabinet/api/courier-app/take_info/${order_id}/set-wait-list-status`, payload)
}

export function resendOrder(order_id: number): ApiSetWaitListStatusResponse {
    return http.put('/cabinet/api/admin/orders/resend-dispatcher', { ids: [order_id] })
}

export function downloadReport(params: DownloadReportParams): ApiDownloadReportResponse {
    return http.get(`/dispatcher/api/order-take/report`, { params, responseType: 'blob' })
}

export function getComments(typeId: number): ApiGetTakeCommentsResponse {
    return http.get('/dispatcher/api/comment-template', { params: { typeId } })
}

export default {
    getTakeOrders,
    assignOrder,
    changeOrderTakeDate,
    getWaitListStatuses,
    setWaitListStatus,
    downloadReport,
    getTakeOrder,
    confirmDate,
    resendOrder,
    getComments,
}
